var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
import IntersectionUtils from '../math/intersectionUtils';
import { useNodeState } from './nodeState';
import { useInteractiveDiagramContext } from './InteractiveDiagramContext';
export var useLinkState = function (id) {
    var diagramContext = useInteractiveDiagramContext();
    var _a = diagramContext.state.links[id], source = _a.source, target = _a.target;
    var _b = useNodeState(source), sourceNodePosition = _b[0], sourceNodeShape = _b[1];
    var _c = useNodeState(target), targetNodePosition = _c[0], targetNodeShape = _c[1];
    var _d = useMemo(function () {
        if (sourceNodePosition && sourceNodeShape && targetNodePosition && targetNodeShape) {
            var linksBetweenNodes = getLinksBetweenNodes(diagramContext.state, source, target);
            var points = IntersectionUtils.findNodePoints(sourceNodeShape, sourceNodePosition, targetNodeShape, targetNodePosition, linksBetweenNodes.length);
            for (var i = 0; i < linksBetweenNodes.length; i++) {
                if (linksBetweenNodes[i].id === id) {
                    return [points.leftNodePoints[i], points.rightNodePoints[i]];
                }
            }
        }
        return [null, null];
    }, [sourceNodePosition, sourceNodeShape, targetNodePosition, targetNodeShape]), linkSourcePosition = _d[0], linkTargetPosition = _d[1];
    return [
        linkSourcePosition,
        linkTargetPosition,
        sourceNodePosition,
        sourceNodeShape,
    ];
};
var getLinksBetweenNodes = function (state, leftNodeId, rightNodeId) {
    return __spreadArray(__spreadArray([], Object.values(state.links).filter(function (link) { return (leftNodeId === link.source && rightNodeId === link.target); }), true), Object.values(state.links).filter(function (link) { return (leftNodeId === link.target && rightNodeId === link.source); }), true);
};
//# sourceMappingURL=linkState.js.map